import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnpin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unpin-2"><path d="M19.25 15.25C19.25 12.6184 17.8479 10.3143 15.75 9.04395V2.75H8M9 8.7L8.25 9.04395C6.1521 10.3143 4.75 12.6184 4.75 15.25H15.5" stroke="currentColor" strokeWidth="1.5"/><path d="M11.25 20.25V15H12.753V20.25L12 22L11.25 20.25Z" fill="currentColor"/><path d="M3 2L20 20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUnpin2;
